'use es6';

import { List, Record } from 'immutable';
import Criterion from './Criterion';
const DEFAULTS = {
  criteria: List(),
  id: 0,
  moduleName: '',
  name: ''
};
export default class Definition extends Record(DEFAULTS) {
  static fromJS(data) {
    return new Definition({
      criteria: List(data.criteria).map(Criterion.fromJS),
      id: data.id,
      moduleName: data.moduleName,
      name: data.name
    });
  }
}